import React, { createContext, useContext, useState, ReactNode } from "react";

interface RouteData {
  routeCode: string;
  routeName: string;
  routeLabel: string;
  startLocation: string;
  endLocation: string;
  comment: string;
}

interface RouteContextProps {
  routeData: RouteData;
  isRouteDataSaved: boolean;
  setRouteData: React.Dispatch<React.SetStateAction<RouteData>>;
  setIsRouteDataSaved: React.Dispatch<React.SetStateAction<boolean>>;
}

const defaultRouteData: RouteData = {
  routeCode: "",
  routeName: "",
  routeLabel: "",
  startLocation: "",
  endLocation: "",
  comment: "",
};

const RouteContext = createContext<RouteContextProps | undefined>(undefined);

export const RouteProvider = ({ children }: { children: ReactNode }) => {
  const [routeData, setRouteData] = useState<RouteData>(defaultRouteData);
  const [isRouteDataSaved, setIsRouteDataSaved] = useState<boolean>(false);

  return (
    <RouteContext.Provider
      value={{ routeData, setRouteData, isRouteDataSaved, setIsRouteDataSaved }}
    >
      {children}
    </RouteContext.Provider>
  );
};

export const useRouteContext = () => {
  const context = useContext(RouteContext);
  if (!context) {
    throw new Error("useRouteContext must be used within a RouteProvider");
  }
  return context;
};
